import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import DrawerBody from 'src/components/drawers/DrawerBody';
import DrawerFooter from 'src/components/drawers/DrawerFooter';
import DrawerTitle from 'src/components/drawers/DrawerTitle';

interface VerificationSuccessfulProps {
    onClose: () => void;
    onContinue: () => void;
}
export const VerificationSuccessful = (props: VerificationSuccessfulProps) => {
    const { onContinue } = props;
    const { palette } = useTheme();
    return (
        <>
            <DrawerTitle>
                <FontAwesomeIcon icon={faCircleCheck} size="3x" color={palette.success.main} />
            </DrawerTitle>
            <DrawerBody sx={{ p: 2.5, gap: 2, textAlign: 'center' }}>
                <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
                    Phone number verified
                </Typography>
                <Typography variant="body1">
                    You&apos;ll receive shift alerts via SMS during your shift.
                </Typography>
                <Typography variant="body1">
                    You may stop these messages at any time by ending your shift.
                </Typography>
            </DrawerBody>
            <DrawerFooter>
                <Button
                    fullWidth
                    disableElevation
                    color="primary"
                    variant="contained"
                    onClick={onContinue}
                >
                    Got it
                </Button>
            </DrawerFooter>
        </>
    );
};
